<template>
  <div class="error-details">
    <a-render-html
      v-if="message"
      :html="message"
      class="error-details__info text-body"
    />

    <div class="error-details__divider" />

    <a-contact class="error__block_contact" />
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AContact from '@/components/_layout/Error/AContact'
import ARenderHtml from 'shared/ARenderHtml'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'AErrorDetails',
  components: {
    AContact,
    ARenderHtml
  },
  props: {
    message: propValidator([PROP_TYPES.STRING], false)
  },
  data() {
    return {
      ROUTE_NAME
    }
  }
}
</script>

<style lang="scss" scoped>
.error-details__info {
  text-align: left;

  /deep/ a {
    color: $c--main;
  }

  @include mobile {
    width: 100%;
  }
}

.error__block_contact {
  width: 100%;
}

.error-details__divider {
  width: 100%;
  height: 1px;
  background: $c--gray-light;
  margin: 32px 0;

  @include mobile {
    margin: 24px 0;
  }
}
</style>
